import React from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import converter from 'number-to-words';
import { connect } from 'react-redux';

import { validateEmail } from 'mytime-common/forms/validate-email.js';
import { getClient } from '../../data/client/ClientActions.js';
import { searchClients } from '../../data/client/ClientServices';
import {
  ClientPerson,
  Circle,
  CircleCheck,
  Backdrop,
} from '../../components/Themed.js';
import './ClientSelection.css';
import { t } from '../../locales';

class ClientSelection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      clients: [],
    };

    this.renderPerson = this.renderPerson.bind(this);
  }

  async componentDidMount() {
    const urlParams = queryString.parse(window.location.search);

    if (urlParams.phoneOrEmail) {
      const clients = await searchClients(urlParams.phoneOrEmail);
      this.setState({
        phoneOrEmail: urlParams.phoneOrEmail,
        clients,
        isCheckingIn: urlParams.isCheckingIn,
        isCheckingInClass: urlParams.isCheckingInClass,
      });
    }
  }

  async selectClient(clientId) {
    const { history, getClient } = this.props;
    const { phoneOrEmail, isCheckingIn, isCheckingInClass } = this.state;

    await getClient(clientId);

    let baseUrl = isCheckingIn ? '/clientCheckin' : '/clientInformation';
    if (isCheckingInClass) {
      baseUrl = '/classCheckin'
    }

    history.push(
      `${baseUrl}?clientId=${clientId}&phoneOrEmail=${phoneOrEmail}`
    );
  }

  renderPerson(firstName, lastName, clientId, childId, selected, onClick) {
    return (
      <ClientPerson
        key={clientId + '_' + childId}
        className={childId ? 'client-selection-child' : ''}
        selected={selected}
        onClick={onClick}
      >
        <Circle>
          <CircleCheck
            className="fas fa-check"
            style={{
              opacity: selected ? 1 : 0,
            }}
          />
        </Circle>
        <div className="client-selection-text">
          {firstName + (lastName ? ' ' + lastName : '')}
        </div>
      </ClientPerson>
    );
  }
  render() {
    const { clients, phoneOrEmail } = this.state;
    const isEmail = validateEmail(phoneOrEmail);

    let numberOfClients = converter.toWords(clients.length);
    numberOfClients =
      numberOfClients.charAt(0).toUpperCase() + numberOfClients.slice(1);

    return (
      <React.Fragment>
        <Backdrop id="backdrop" />
        <div className="scroll-container content-container">
          <div className="page-container">
            <div className="return-client">
              {clients.length > 0 && (
                <React.Fragment>
                  <div className="client-selection-title">
                    {t('client_selection.we_found')} {numberOfClients}{' '}
                    {t('client_selection.clients_with_this')}
                    <br />
                    {isEmail
                      ? t('new_client.email')
                      : t('new_client.phone_number')}
                  </div>
                  <div className="client-selection-subtitle">
                    {t('client_selection.which_one_are_you')}
                  </div>
                  <div className="content content-padding">
                    <div className="client-selection-container">
                      {clients.map(c =>
                        this.renderPerson(
                          c.first_name,
                          c.last_name,
                          c.client_id,
                          c.id,
                          false,
                          () => this.selectClient(c.id)
                        )
                      )}
                    </div>
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(
  connect(
    undefined,
    {
      getClient,
    }
  )(ClientSelection)
);
